// extracted by mini-css-extract-plugin
export default {"wrapper":"fk","form":"gk","circle":"hk","success":"ik","button":"jk"};